export const globalPromotionsManager = {
  header: {
    title: "Gestionnaire de promotions",
    description:
      "Créez et gérez des promotions de séjour valables sur tout le compte. Elles seront disponibles pour tous vos établissements (appartements et hôtels).",
  },

  toolbar: {
    info: "Les promotions créées ici peuvent être activées depuis l'onglet <strong>Promotions</strong> de chaque établissement.",
    newPromotion: "Nouvelle promotion",
  },

  loading: "Chargement des promotions...",
  close: "Fermer",
  cancel: "Annuler",
  noLimit: "Aucune limite",

  status: {
    active: "Active",
    paused: "Suspendue",
  },

  card: {
    stay: "Séjour",
    discount: "Remise",
    validity: "Validité",
    edit: "Modifier",
    delete: "Supprimer",
  },

  nights: {
    range: "{min} – {max} nuits",
    min: "{min}+ nuits",
  },

  discount: {
    fixed: "{value} (fixe)",
  },

  empty: {
    title: "Aucune promotion créée",
    description:
      "Créez des promotions pour encourager les séjours plus longs. Vous pouvez les activer sur chaque établissement depuis ses paramètres de réservations directes.",
    create: "Créer la première promotion",
  },

  form: {
    editTitle: "Modifier la promotion",
    createTitle: "Nouvelle promotion",
    nameLabel: "Nom de la promotion",
    namePlaceholder: "ex. remise 7 nuits, offre hebdomadaire",
    minNights: "Nuits minimum",
    maxNights: "Nuits maximum",
    optional: "(facultatif)",
    noLimitPlaceholder: "Aucune limite",
    discountType: "Type de remise",
    percentage: "Pourcentage",
    fixedAmount: "Montant fixe",
    discountValue: "Valeur de la remise",
    amountSuffix: "montant",
    validFrom: "Valable à partir du",
    validTo: "Valable jusqu'au",
    activateNow: "Activer la promotion immédiatement",
    propertiesLabel: "Établissements où elle sera disponible",
    selectAll: "Tout sélectionner",
    propertiesHelper:
      "Des enregistrements de configuration seront créés pour les établissements sélectionnés.",
    infoBox:
      "Vous pourrez ensuite ajuster le badge, l'ordre et le comportement depuis l'onglet <strong>Promotions</strong> de chaque établissement.",
    saving: "Enregistrement...",
    update: "Mettre à jour",
    create: "Créer la promotion",
  },

  deleteModal: {
    title: "Supprimer la promotion",
    warningStrong: "Cette action est irréversible.",
    warningBefore: "Vous êtes sur le point de supprimer la promotion",
    warningAfter: ". Elle ne sera plus disponible sur aucun établissement.",
    confirmLabel: "Saisissez le nom exact pour confirmer :",
    confirmPlaceholder: "Saisissez le nom de la promotion",
    deleting: "Suppression...",
    confirmDelete: "Supprimer définitivement",
  },

  toasts: {
    loadError: "Impossible de charger les promotions.",
    nameRequired: "Saisissez un nom pour la promotion",
    minNightsWarning: "Le nombre de nuits minimum doit être d'au moins 1",
    discountValueWarning: "La valeur de la remise doit être supérieure à 0",
    selectProperty: "Sélectionnez au moins un établissement",
    updated: "Promotion mise à jour",
    created: "Promotion créée avec succès",
    saveFailed: "Impossible d'enregistrer",
    saveError: "Erreur lors de l'enregistrement de la promotion",
    deleted: "Promotion supprimée",
    deleteFailed: "Impossible de supprimer",
    deleteError: "Erreur lors de la suppression",
  },
};
